import { r as registerInstance, h } from './index-d4808923.js';

const gravityIconIndividualCss = ":host{display:contents}";
const GravityIconAssetVrStyle0 = gravityIconIndividualCss;

const GravityIconAssetVr = class {
    constructor(hostRef) {
        registerInstance(this, hostRef);
        this.color = 'dark';
        this.size = 'xx-small';
    }
    render() {
        return (h("internal-gravity-base-icon", { key: 'ceaf3eac241a371b864291d2e40ddfd91457cadb', color: this.color, size: this.size }, h("svg", { key: '0739ea5cae77f728db7894bd3cafb6b22275b2f1', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, h("path", { key: 'eb6bbaade829b5f92b0fcb677d79fd4778b63eea', "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M10.8 6.37a22.44 22.44 0 0 0-8.49 1.69.51.51 0 0 0-.31.47v5.36c0 .205.122.39.31.47 1.96.804 4.024 1.33 6.13 1.56a.5.5 0 0 0 .56-.5V15a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v.38a.5.5 0 0 0 .56.5 20.122 20.122 0 0 0 6.15-1.69.49.49 0 0 0 .29-.45V8.69a.5.5 0 0 0-.29-.46 21.62 21.62 0 0 0-8.91-1.86Zm-7.08 3.82 1.93-1.93a.5.5 0 0 1 .71 0l.36.36a.5.5 0 0 1 0 .71l-1.93 1.93a.5.5 0 0 1-.7 0l-.37-.37a.5.5 0 0 1 0-.7ZM6.84 12l-.36-.36a.5.5 0 0 1 0-.71l2.71-2.71a.5.5 0 0 1 .71 0l.36.36a.5.5 0 0 1 0 .71L7.55 12a.51.51 0 0 1-.71 0Z", fill: "currentColor" }))));
    }
};
GravityIconAssetVr.style = GravityIconAssetVrStyle0;

export { GravityIconAssetVr as gravity_icon_asset_vr };

//# sourceMappingURL=gravity-icon-asset-vr.entry.js.map